export default __webpack_public_path__ + "static/media/asrneural.3560fc88.png";